export const timezones = [
  {
    id: 'Etc/GMT+12',
    name: '(UTC-12:00) International Date Line West',
  },
  {
    id: 'Etc/GMT+11',
    name: '(UTC-11:00) Coordinated Universal Time-11',
  },
  {
    id: 'Pacific/Honolulu',
    name: '(UTC-10:00) Hawaii',
  },
  {
    id: 'America/Adak',
    name: '(UTC-10:00) Aleutian Islands',
  },
  {
    id: 'Pacific/Marquesas',
    name: '(UTC-09:30) Marquesas Islands',
  },
  {
    id: 'Etc/GMT+9',
    name: '(UTC-09:00) Coordinated Universal Time-09',
  },
  {
    id: 'America/Anchorage',
    name: '(UTC-09:00) Alaska',
  },
  {
    id: 'Etc/GMT+8',
    name: '(UTC-08:00) Coordinated Universal Time-08',
  },
  {
    id: 'America/Tijuana',
    name: '(UTC-08:00) Baja California',
  },
  {
    id: 'America/Los_Angeles',
    name: '(UTC-08:00) Pacific Time (US & Canada)',
  },
  {
    id: 'America/Whitehorse',
    name: '(UTC-07:00) Yukon',
  },
  {
    id: 'America/Phoenix',
    name: '(UTC-07:00) Arizona',
  },
  {
    id: 'America/Chihuahua',
    name: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
  },
  {
    id: 'America/Denver',
    name: '(UTC-07:00) Mountain Time (US & Canada)',
  },
  {
    id: 'Pacific/Easter',
    name: '(UTC-06:00) Easter Island',
  },
  {
    id: 'America/Mexico_City',
    name: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
  },
  {
    id: 'America/Chicago',
    name: '(UTC-06:00) Central Time (US & Canada)',
  },
  {
    id: 'America/Guatemala',
    name: '(UTC-06:00) Central America',
  },
  {
    id: 'America/Regina',
    name: '(UTC-06:00) Saskatchewan',
  },
  {
    id: 'America/Indianapolis',
    name: '(UTC-05:00) Indiana (East)',
  },
  {
    id: 'America/Grand_Turk',
    name: '(UTC-05:00) Turks and Caicos',
  },
  {
    id: 'America/Bogota',
    name: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
  },
  {
    id: 'America/Port-au-Prince',
    name: '(UTC-05:00) Haiti',
  },
  {
    id: 'America/Cancun',
    name: '(UTC-05:00) Chetumal',
  },
  {
    id: 'America/New_York',
    name: '(UTC-05:00) Eastern Time (US & Canada)',
  },
  {
    id: 'America/Havana',
    name: '(UTC-05:00) Havana',
  },
  {
    id: 'America/Caracas',
    name: '(UTC-04:00) Caracas',
  },
  {
    id: 'America/La_Paz',
    name: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
  },
  {
    id: 'America/Asuncion',
    name: '(UTC-04:00) Asuncion',
  },
  {
    id: 'America/Santiago',
    name: '(UTC-04:00) Santiago',
  },
  {
    id: 'America/Cuiaba',
    name: '(UTC-04:00) Cuiaba',
  },
  {
    id: 'America/Halifax',
    name: '(UTC-04:00) Atlantic Time (Canada)',
  },
  {
    id: 'America/St_Johns',
    name: '(UTC-03:30) Newfoundland',
  },
  {
    id: 'America/Araguaina',
    name: '(UTC-03:00) Araguaina',
  },
  {
    id: 'America/Miquelon',
    name: '(UTC-03:00) Saint Pierre and Miquelon',
  },
  {
    id: 'America/Cayenne',
    name: '(UTC-03:00) Cayenne, Fortaleza',
  },
  {
    id: 'America/Montevideo',
    name: '(UTC-03:00) Montevideo',
  },
  {
    id: 'America/Punta_Arenas',
    name: '(UTC-03:00) Punta Arenas',
  },
  {
    id: 'America/Godthab',
    name: '(UTC-03:00) Greenland',
  },
  {
    id: 'America/Sao_Paulo',
    name: '(UTC-03:00) Brasilia',
  },
  {
    id: 'America/Bahia',
    name: '(UTC-03:00) Salvador',
  },
  {
    id: 'America/Buenos_Aires',
    name: '(UTC-03:00) City of Buenos Aires',
  },
  {
    id: 'Etc/GMT+2',
    name: '(UTC-02:00) Coordinated Universal Time-02',
  },
  {
    id: 'Atlantic/Azores',
    name: '(UTC-01:00) Azores',
  },
  {
    id: 'Atlantic/Cape_Verde',
    name: '(UTC-01:00) Cabo Verde Is.',
  },
  {
    id: 'Etc/GMT',
    name: '(UTC) Coordinated Universal Time',
  },
  {
    id: 'Europe/London',
    name: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
  },
  {
    id: 'Atlantic/Reykjavik',
    name: '(UTC+00:00) Monrovia, Reykjavik',
  },
  {
    id: 'Africa/Sao_Tome',
    name: '(UTC+00:00) Sao Tome',
  },
  {
    id: 'Europe/Budapest',
    name: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
  },
  {
    id: 'Europe/Warsaw',
    name: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
  },
  {
    id: 'Africa/Casablanca',
    name: '(UTC+01:00) Casablanca',
  },
  {
    id: 'Europe/Paris',
    name: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
  },
  {
    id: 'Africa/Lagos',
    name: '(UTC+01:00) West Central Africa',
  },
  {
    id: 'Europe/Berlin',
    name: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
  },
  {
    id: 'Europe/Chisinau',
    name: '(UTC+02:00) Chisinau',
  },
  {
    id: 'Africa/Cairo',
    name: '(UTC+02:00) Cairo',
  },
  {
    id: 'Europe/Kiev',
    name: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
  },
  {
    id: 'Europe/Bucharest',
    name: '(UTC+02:00) Athens, Bucharest',
  },
  {
    id: 'Asia/Jerusalem',
    name: '(UTC+02:00) Jerusalem',
  },
  {
    id: 'Asia/Amman',
    name: '(UTC+02:00) Amman',
  },
  {
    id: 'Europe/Kaliningrad',
    name: '(UTC+02:00) Kaliningrad',
  },
  {
    id: 'Africa/Tripoli',
    name: '(UTC+02:00) Tripoli',
  },
  {
    id: 'Asia/Beirut',
    name: '(UTC+02:00) Beirut',
  },
  {
    id: 'Africa/Windhoek',
    name: '(UTC+02:00) Windhoek',
  },
  {
    id: 'Africa/Johannesburg',
    name: '(UTC+02:00) Harare, Pretoria',
  },
  {
    id: 'Africa/Khartoum',
    name: '(UTC+02:00) Khartoum',
  },
  {
    id: 'Asia/Damascus',
    name: '(UTC+02:00) Damascus',
  },
  {
    id: 'Asia/Hebron',
    name: '(UTC+02:00) Gaza, Hebron',
  },
  {
    id: 'Asia/Riyadh',
    name: '(UTC+03:00) Kuwait, Riyadh',
  },
  {
    id: 'Asia/Baghdad',
    name: '(UTC+03:00) Baghdad',
  },
  {
    id: 'Europe/Minsk',
    name: '(UTC+03:00) Minsk',
  },
  {
    id: 'Africa/Nairobi',
    name: '(UTC+03:00) Nairobi',
  },
  {
    id: 'Europe/Moscow',
    name: '(UTC+03:00) Moscow, St. Petersburg',
  },
  {
    id: 'Europe/Istanbul',
    name: '(UTC+03:00) Istanbul',
  },
  {
    id: 'Asia/Tehran',
    name: '(UTC+03:30) Tehran',
  },
  {
    id: 'Asia/Dubai',
    name: '(UTC+04:00) Abu Dhabi, Muscat',
  },
  {
    id: 'Europe/Astrakhan',
    name: '(UTC+04:00) Astrakhan, Ulyanovsk',
  },
  {
    id: 'Asia/Baku',
    name: '(UTC+04:00) Baku',
  },
  {
    id: 'Asia/Yerevan',
    name: '(UTC+04:00) Yerevan',
  },
  {
    id: 'Asia/Tbilisi',
    name: '(UTC+04:00) Tbilisi',
  },
  {
    id: 'Indian/Mauritius',
    name: '(UTC+04:00) Port Louis',
  },
  {
    id: 'Europe/Samara',
    name: '(UTC+04:00) Izhevsk, Samara',
  },
  {
    id: 'Europe/Saratov',
    name: '(UTC+04:00) Saratov',
  },
  {
    id: 'Europe/Volgograd',
    name: '(UTC+04:00) Volgograd',
  },
  {
    id: 'Asia/Kabul',
    name: '(UTC+04:30) Kabul',
  },
  {
    id: 'Asia/Yekaterinburg',
    name: '(UTC+05:00) Ekaterinburg',
  },
  {
    id: 'Asia/Karachi',
    name: '(UTC+05:00) Islamabad, Karachi',
  },
  {
    id: 'Asia/Qyzylorda',
    name: '(UTC+05:00) Qyzylorda',
  },
  {
    id: 'Asia/Tashkent',
    name: '(UTC+05:00) Ashgabat, Tashkent',
  },
  {
    id: 'Asia/Calcutta',
    name: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
  },
  {
    id: 'Asia/Colombo',
    name: '(UTC+05:30) Sri Jayawardenepura',
  },
  {
    id: 'Asia/Katmandu',
    name: '(UTC+05:45) Kathmandu',
  },
  {
    id: 'Asia/Dhaka',
    name: '(UTC+06:00) Dhaka',
  },
  {
    id: 'Asia/Almaty',
    name: '(UTC+06:00) Astana',
  },
  {
    id: 'Asia/Omsk',
    name: '(UTC+06:00) Omsk',
  },
  {
    id: 'Asia/Rangoon',
    name: '(UTC+06:30) Yangon (Rangoon)',
  },
  {
    id: 'Asia/Barnaul',
    name: '(UTC+07:00) Barnaul, Gorno-Altaysk',
  },
  {
    id: 'Asia/Novosibirsk',
    name: '(UTC+07:00) Novosibirsk',
  },
  {
    id: 'Asia/Krasnoyarsk',
    name: '(UTC+07:00) Krasnoyarsk',
  },
  {
    id: 'Asia/Bangkok',
    name: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
  },
  {
    id: 'Asia/Tomsk',
    name: '(UTC+07:00) Tomsk',
  },
  {
    id: 'Asia/Hovd',
    name: '(UTC+07:00) Hovd',
  },
  {
    id: 'Asia/Shanghai',
    name: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
  },
  {
    id: 'Asia/Irkutsk',
    name: '(UTC+08:00) Irkutsk',
  },
  {
    id: 'Asia/Singapore',
    name: '(UTC+08:00) Kuala Lumpur, Singapore',
  },
  {
    id: 'Asia/Taipei',
    name: '(UTC+08:00) Taipei',
  },
  {
    id: 'Asia/Ulaanbaatar',
    name: '(UTC+08:00) Ulaanbaatar',
  },
  {
    id: 'Australia/Perth',
    name: '(UTC+08:00) Perth',
  },
  {
    id: 'Australia/Eucla',
    name: '(UTC+08:45) Eucla',
  },
  {
    id: 'Asia/Seoul',
    name: '(UTC+09:00) Seoul',
  },
  {
    id: 'Asia/Pyongyang',
    name: '(UTC+09:00) Pyongyang',
  },
  {
    id: 'Asia/Tokyo',
    name: '(UTC+09:00) Osaka, Sapporo, Tokyo',
  },
  {
    id: 'Asia/Chita',
    name: '(UTC+09:00) Chita',
  },
  {
    id: 'Asia/Yakutsk',
    name: '(UTC+09:00) Yakutsk',
  },
  {
    id: 'Australia/Darwin',
    name: '(UTC+09:30) Darwin',
  },
  {
    id: 'Australia/Adelaide',
    name: '(UTC+09:30) Adelaide',
  },
  {
    id: 'Australia/Sydney',
    name: '(UTC+10:00) Canberra, Melbourne, Sydney',
  },
  {
    id: 'Australia/Brisbane',
    name: '(UTC+10:00) Brisbane',
  },
  {
    id: 'Australia/Hobart',
    name: '(UTC+10:00) Hobart',
  },
  {
    id: 'Asia/Vladivostok',
    name: '(UTC+10:00) Vladivostok',
  },
  {
    id: 'Pacific/Port_Moresby',
    name: '(UTC+10:00) Guam, Port Moresby',
  },
  {
    id: 'Australia/Lord_Howe',
    name: '(UTC+10:30) Lord Howe Island',
  },
  {
    id: 'Pacific/Bougainville',
    name: '(UTC+11:00) Bougainville Island',
  },
  {
    id: 'Pacific/Guadalcanal',
    name: '(UTC+11:00) Solomon Is., New Caledonia',
  },
  {
    id: 'Asia/Magadan',
    name: '(UTC+11:00) Magadan',
  },
  {
    id: 'Pacific/Norfolk',
    name: '(UTC+11:00) Norfolk Island',
  },
  {
    id: 'Asia/Srednekolymsk',
    name: '(UTC+11:00) Chokurdakh',
  },
  {
    id: 'Asia/Sakhalin',
    name: '(UTC+11:00) Sakhalin',
  },
  {
    id: 'Pacific/Fiji',
    name: '(UTC+12:00) Fiji',
  },
  {
    id: 'Pacific/Auckland',
    name: '(UTC+12:00) Auckland, Wellington',
  },
  {
    id: 'Asia/Kamchatka',
    name: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
  },
  {
    id: 'Etc/GMT-12',
    name: '(UTC+12:00) Coordinated Universal Time+12',
  },
  {
    id: 'Pacific/Chatham',
    name: '(UTC+12:45) Chatham Islands',
  },
  {
    id: 'Pacific/Apia',
    name: '(UTC+13:00) Samoa',
  },
  {
    id: 'Pacific/Tongatapu',
    name: "(UTC+13:00) Nuku'alofa",
  },
  {
    id: 'Etc/GMT-13',
    name: '(UTC+13:00) Coordinated Universal Time+13',
  },
  {
    id: 'Pacific/Kiritimati',
    name: '(UTC+14:00) Kiritimati Island',
  },
];
